import IdvLimited from './idv-limited';

export default IdvLimited;
